import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import SidebarContext from "../../store/SidebarContext";
import { useContext } from "react";
import Page from "../../components/DefaultPage/DefaultPage";
import classes from "./ObjectiveStats.module.css";
import LoadingPage from "../LoadingPage/LoadingPage";
// import MaterialIcon from "react-google-material-icons";

function ObjectiveStats() {
  const sidebarCtx = useContext(SidebarContext);
  const isSidebar = sidebarCtx.sidebar;
  const [isLoading, setIsLoading] = useState(false);
  const [loadedObjectives, setLoadedObjectives] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOption, setSortOption] = useState("");
  const { t } = useTranslation("global");
  const ip = process.env.REACT_APP_SERVER_IP;
  const port = process.env.REACT_APP_SERVER_PORT;
  const protocol = process.env.REACT_APP_SERVER_PROTOCOL;
  const serverPath = protocol + "://" + ip + ":" + port;
  const allObjectivesPath = serverPath + "/all-objectives";

  
  useEffect(() => {
    setIsLoading(true);
    fetch(allObjectivesPath, {
      method: 'POST',
      body: JSON.stringify({}), // Sending an empty string as JSON
      headers: {
        'Content-Type': 'application/json'
        // Add any other headers if required
      }
    })
    .then((response) => {
      return response.json();
    })
    .then((objectives) => {
      setIsLoading(false);
      setLoadedObjectives(Object.values(objectives));
    })
    .catch((error) => {
      console.error('Error fetching objectives:', error);
      setIsLoading(false);
      // Handle error state as needed
    });
  }, []);
  

  const filteredObjectives = loadedObjectives.filter((objective) =>
    objective.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const convertToDateObject = (dateString) => {
    const [day, month, yearHourMinute] = dateString.split("-");
    const [year, hourMinute] = yearHourMinute.split(" ");
    const [hour, minute] = hourMinute.split(":");
    const isoDate = `${year}-${month}-${day}T${hour}:${minute}:00`;
    return new Date(isoDate);
  };

  const sortedObjectives = filteredObjectives.sort((a, b) => {
    if (sortOption === "creationDate") {
      return (
        convertToDateObject(a.creationDate) -
        convertToDateObject(b.creationDate)
      );
    } else if (sortOption === "dueDate") {
      return convertToDateObject(b.dueDate) - convertToDateObject(a.dueDate);
    } else if (sortOption === "pointValue") {
      return b.pointValue - a.pointValue;
    } else {
      return 0;
    }
  });

  if (isLoading) {
    return (
      <section>
        <LoadingPage />
      </section>
    );
  }

  return (
    <Page>
      <div style={{ marginTop: "5rem" }}>
      <h1>{t("stats.titles.objectiveOverview")}</h1>
        <div style={{display: "flex", justifyContent: "left", alignItems: "center"}}>
          {/* <MaterialIcon
            className="search-icon"
            icon="search"
            size={24}
            color="rgba(0, 0, 0, 0.54)"
          /> */}
         
                    <input
  className={classes.searchbar}
  type="text"
  placeholder={t("sorter.searchBar.placeholder")}
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
  style={{
    background: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23000000" width="24px" height="24px"><path d="M0 0h24v24H0z" fill="none"/><path d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 0 0 1.48-5.34c-.47-2.78-2.79-5-5.59-5.34a6.505 6.505 0 0 0-7.27 7.27c.34 2.8 2.56 5.12 5.34 5.59a6.5 6.5 0 0 0 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/></svg>') no-repeat 5px center`,
    paddingLeft: "30px", // Adjust padding to fit the icon
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: "16px", // Adjust font size to fit the icon
    lineHeight: "1.5",
    border: "2px solid #067451",
    borderRadius: "4px",
    boxSizing: "border-box",
    width: "100%",
    height: "36px",
    outline: "none"
  }}
/>
        
        <select
          value={sortOption}
          onChange={(e) => setSortOption(e.target.value)}
          className={classes.sort}
        >
          <option value="" disabled hidden>
            {t("sorter.selectButtonLabels.sortBy")}
          </option>
          <option value="creationDate">
            {t("sorter.selectButtonLabels.creationDate")}
          </option>
          <option value="dueDate">
            {t("sorter.selectButtonLabels.dueDate")}
          </option>
          <option value="pointValue">
            {t("sorter.selectButtonLabels.pointValue")}
          </option>
        </select>
        </div>
      </div>
      <table className={classes.table}>
        <thead>
          <tr>
            <th>{t("stats.columns.title")}</th>
            <th>{t("stats.columns.description")}</th>
            <th>{t("stats.columns.coolDownTime")}</th>
            <th>{t("stats.columns.maxScans")}</th>
            <th>{t("stats.columns.pointValue")}</th>
            <th>{t("stats.columns.dueDate")}</th>
            <th>{t("stats.columns.creationDate")}</th>
            <th>{t("stats.columns.repCounter")}</th>
            <th>{t("stats.columns.refreshRate")}</th>
          </tr>
        </thead>
        <tbody>
          {sortedObjectives.map((val, key) => {
            return (
              <tr key={key}>
                <td>{val.title}</td>
                <td>{val.description}</td>
                <td>{val.coolDownTime}</td>
                <td>{val.maxScans}</td>
                <td>{val.pointValue}</td>
                <td>{val.dueDate}</td>
                <td>{val.creationDate}</td>
                <td>{val.repCounter}</td>
                <td>{val.refreshRate}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </Page>
  );
}

export default ObjectiveStats;
